import { Component, Prop, Watch, getAssetPath } from "@stencil/core";

@Component({
    tag: "ux-cookie-layer-theme",
    assetsDirs: ["themes"],
    shadow: false,
})
export class CookieLayerTheme {
    private styleSheetUrl: string;
    private nextStyleSheetUrl: string;

    /** The theme that should be applied  */
    @Prop() theme: "web" | "responsive" = "web";

    @Watch("theme")
    setTheme() {
        const styleSheetUrl = getAssetPath(`./themes/${this.theme}.css`);
        if (this.styleSheetUrl === styleSheetUrl) {
            return;
        }
        this.nextStyleSheetUrl = styleSheetUrl;
        const stylesheet: HTMLLinkElement = document.createElement("link");
        stylesheet.type = "text/css";
        stylesheet.rel = "stylesheet";
        stylesheet.href = styleSheetUrl;
        stylesheet.onload = () => {
            this.switchStylesheet(styleSheetUrl);
        };
        document.getElementsByTagName("head")[0].appendChild(stylesheet);
    }

    componentWillLoad() {
        this.setTheme();
    }

    private switchStylesheet = (styleSheetUrl: string) => {
        if (styleSheetUrl !== this.nextStyleSheetUrl) {
            return;
        }
        if (this.styleSheetUrl !== null) {
            const previousStylesheet: HTMLStyleElement = document.querySelector(
                `link[rel="stylesheet"][href="${this.styleSheetUrl}"]`
            ) as HTMLStyleElement;
            if (previousStylesheet !== null) {
                previousStylesheet.parentElement.removeChild(
                    previousStylesheet
                );
            }
        }
        this.styleSheetUrl = styleSheetUrl;
        this.nextStyleSheetUrl = null;
    };
}
